module.exports = __webpack_public_path__ + "img/logo.c7215fce.png";